module.exports = __webpack_public_path__ + "img/feature_buy_en.ba984cb4.png";